/* eslint-disable no-console */
/* eslint-disable global-require */
import { VERSION } from './version';
export { IdentityButton, getTokenDescription, ButtonMode, GatewayStatus } from '@civic/common-gateway-react';
export { default as Badge } from './badge';
export { useSolanaGateway as useGateway } from './chainImplementation';
export { SolanaGatewayProvider as GatewayProvider } from './SolanaGatewayProvider';
console.log(VERSION);
